export const LOGIN = "/user/login";
export const AUTHEN = "/api/auth";
export const CUSTOMER = "/user";
export const ADMIN = "/user";
export const CATEGORY = "/category";
export const SONG = "/song";
export const SALE = "/sale";
export const AUTHOR = "/author";
export const DASHBOARD = "/dashboard";
export const USER = "/api/user";
export const CONVERSATION = "/api/conversation";
export const MESSAGE = "/api/message";
export const MESSAGE_VOTE = "/api/message-vote";
export const MAIL = "/api/mail";
export const USER_MAIL = "/api/user-mail";
export const FORWARD_MAIL = "/api/forward-mail";
export const ORGANIZATION = "/api/organization";
export const USER_CONVERSATION = "/api/user-conversation";
export const LABEL = "/api/label";
export const GOOGLE_DRIVE = "/google-drive";
export const CODE = "/api/code";
export const PROJECT = "/api/project";
export const ATTRIBUTE_TEMPLATE = "/api/attribute-template";
export const TASK = "/api/task";
export const TASK_ATTRIBUTE = "/api/task-attribute";
export const TASK_MEMBER = "/api/task-member";
export const ALARM = "/api/alarm";
export const CALENDAR = "/api/calendar";
export const PROJECT_PROGRESS = "/api/project-progress";
export const TASK_ACTIVITY = "/api/task-activity";
export const REACTION = "/api/reaction";
export const WELCOME_SLIDE = "/api/welcome-screen";
export const CALLING = "/api/calling";
export const MEMBER_SCHEDULE = "/api/member-schedule";
// authentication
export const ORGANIZATION_USER = "/api/organization-user";
export const USER_SCREEN = "/api/user-screen";
export const PREVIEW = "/api/preview";
export const PROJECT_FILE = "/api/file";
export const DRAFT_MAIL = "/api/draft-mail";
export const APP = "/api/app";
export const VERSION = "/api/version";
export const RESOURCE_API = "api/resource";
export const STICKER = "api/sticker";
export const STICKER_PACK = "api/sticker-pack";
export const OFFICE_PREVIEW = "api/v1/preview";
